export default __webpack_public_path__ + "static/swirl-707407454b12760c435320cabde3a80a.png";